/* =========================================================
   LP: 無重力リュック 第5世代 (lp-mugen5)
   sticky CTA / Ajaxカート / variant同期 / fade-up / count-up
   / 動画遅延 / アンカー / GA4イベント(dataLayer+gtag) / reduced-motion
   ========================================================= */
(function () {
  'use strict';
  var root = document.querySelector('[data-lp-mugen5]');
  if (!root) return;

  var LP_NAME = root.getAttribute('data-lp-name') || 'mugen5';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 計測: dataLayer 主軸 + gtag フォールバック ---------- */
  function track(event, params) {
    var payload = Object.assign({ event: event, lp_name: LP_NAME }, params || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        var p = Object.assign({}, payload);
        delete p.event;
        window.gtag('event', event, p);
      }
    } catch (e) {}
  }
  root.__lpTrack = track;

  /* ---------- lp_view ---------- */
  track('lp_view', {});

  /* ---------- スクロール深度 ---------- */
  (function () {
    var marks = [25, 50, 75, 90];
    var fired = {};
    function onScroll() {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH <= 0) return;
      var pct = (window.scrollY / docH) * 100;
      marks.forEach(function (m) {
        if (!fired[m] && pct >= m) {
          fired[m] = true;
          track('lp_scroll_' + m, {});
        }
      });
      if (fired[90]) window.removeEventListener('scroll', onScroll);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------- fade-up ---------- */
  (function () {
    var els = root.querySelectorAll('[data-lp-fade]');
    if (!els.length || reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- count-up ---------- */
  (function () {
    var els = root.querySelectorAll('[data-lp-countup]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-lp-countup')) || 0;
      var suffix = el.getAttribute('data-lp-countup-suffix') || '';
      if (reduceMotion) { el.textContent = target + suffix; return; }
      var dur = 1100, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var val = Math.round(target * (0.5 - Math.cos(p * Math.PI) / 2));
        el.textContent = val + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- 動画遅延(data-lp-video の src を可視時に注入) ---------- */
  (function () {
    var vids = root.querySelectorAll('video[data-lp-src]');
    if (!vids.length) return;
    function load(v) {
      if (v.getAttribute('data-loaded')) return;
      v.src = v.getAttribute('data-lp-src');
      v.setAttribute('data-loaded', '1');
      var play = v.play();
      if (play && play.catch) play.catch(function () {});
      track('lp_video_play', { creative_name: v.getAttribute('data-lp-creative') || '' });
      v.addEventListener('ended', function () {
        track('lp_video_complete', { creative_name: v.getAttribute('data-lp-creative') || '' });
      });
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  /* ---------- FAQ 開閉計測 ---------- */
  root.querySelectorAll('.lp-mugen5__faq-item').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) track('lp_faq_open', { creative_name: (d.querySelector('.lp-mugen5__faq-q') || {}).textContent || '' });
    });
  });

  /* ---------- アンカー: スムーススクロール ---------- */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var tgt = document.querySelector(id);
      if (!tgt) return;
      e.preventDefault();
      tgt.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      track('lp_cta_click', { cta_text: (a.textContent || '').trim(), cta_position: a.getAttribute('data-lp-cta-pos') || 'anchor' });
    });
  });

  /* ---------- 外部CTAクリック計測(非アンカー) ---------- */
  root.querySelectorAll('[data-lp-cta]').forEach(function (a) {
    a.addEventListener('click', function () {
      track('lp_cta_click', { cta_text: (a.textContent || '').trim(), cta_position: a.getAttribute('data-lp-cta-pos') || '' });
    });
  });

  /* =========================================================
     購入ブロック: variant同期 + Ajaxカート
     ========================================================= */
  var pp = root.querySelector('[data-lp-pp]');
  var sticky = document.querySelector('[data-lp-sticky]');
  var variants = [];
  try { variants = JSON.parse((root.querySelector('[data-lp-variants]') || {}).textContent || '[]'); } catch (e) {}

  function fmtPrice(cents) {
    return '¥' + Number(cents / 100).toLocaleString('ja-JP', { maximumFractionDigits: 0 });
  }

  var state = { selected: [], variant: null };

  function findVariant(sel) {
    if (sel.some(function (v) { return !v; })) return null;
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    }) || null;
  }

  function availableValues(optIdx, sel) {
    var s = {};
    variants.forEach(function (v) {
      if (!v.available) return;
      var ok = sel.every(function (val, i) { return i === optIdx || !val || val === v.options[i]; });
      if (ok) s[v.options[optIdx]] = true;
    });
    return s;
  }

  function syncProduct() {
    if (!pp) return;
    state.variant = findVariant(state.selected);
    pp.querySelectorAll('.lp-mugen5__pp-opt-btn').forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-opt-idx'), 10);
      var val = btn.getAttribute('data-opt-val');
      btn.setAttribute('aria-pressed', state.selected[idx] === val ? 'true' : 'false');
      var avail = availableValues(idx, state.selected);
      var keys = Object.keys(avail);
      btn.disabled = keys.length > 0 && !avail[val];
    });
    var priceEl = pp.querySelector('[data-lp-pp-price]');
    var addBtn = pp.querySelector('[data-lp-add]');
    var v = state.variant;
    if (v) {
      if (priceEl) priceEl.innerHTML = fmtPrice(v.price) + '<small>（税込）</small>';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'カートに追加する' : '在庫切れ';
      }
      if (sticky) {
        var sp = sticky.querySelector('[data-lp-sticky-price]');
        if (sp) sp.innerHTML = fmtPrice(v.price) + '<small>（税込）</small>';
      }
    } else {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = (variants.length > 1 ? 'サイズ・カラーを選択してください' : 'カートに追加する'); }
    }
  }

  if (pp) {
    var optCount = ((variants[0] || {}).options || []).length;
    state.selected = new Array(optCount).fill(null);
    // 単一variantは初期選択
    if (variants.length === 1) state.selected = (variants[0].options || []).slice();

    pp.querySelectorAll('.lp-mugen5__pp-opt-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var idx = parseInt(btn.getAttribute('data-opt-idx'), 10);
        var val = btn.getAttribute('data-opt-val');
        state.selected[idx] = state.selected[idx] === val ? null : val;
        syncProduct();
        track('select_item', { product_id: pp.getAttribute('data-product-id') || '', variant_id: state.variant ? state.variant.id : '' });
      });
    });
    syncProduct();
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    var msg = pp ? pp.querySelector('[data-lp-pp-msg]') : null;
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '追加中...'; }
    if (msg) msg.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || e.message || 'カート追加に失敗しました'); });
      return res.json();
    }).then(function () {
      track('add_to_cart', { product_id: pp ? (pp.getAttribute('data-product-id') || '') : '', variant_id: variantId });
      // カートドロワーを開く(テーマのカスタム要素)
      var opened = false;
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) {}
      var drawerOpener = document.querySelector('[data-cart-icon-bubble], a[href="/cart"]');
      var drawerEl = document.getElementById('cart-drawer') || document.querySelector('cart-drawer, drawer-component#Drawer-Cart');
      if (drawerEl && typeof drawerEl.open === 'function') { drawerEl.open(); opened = true; }
      if (!opened) {
        // フォールバック: カートページへ
        setTimeout(function () { window.location.href = '/cart'; }, 150);
      } else {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        // ドロワー再取得を促す
        try { window.location.hash = ''; } catch (e) {}
        fetch('/?sections=cart-drawer').catch(function(){});
      }
    }).catch(function (err) {
      if (msg) msg.textContent = err.message || 'エラーが発生しました';
      if (btn) { btn.disabled = false; btn.textContent = orig; }
    });
  }

  if (pp) {
    var addBtn = pp.querySelector('[data-lp-add]');
    if (addBtn) addBtn.addEventListener('click', function () {
      if (!state.variant || !state.variant.available) return;
      track('lp_cta_click', { cta_text: 'カートに追加する', cta_position: 'product_picker' });
      addToCart(state.variant.id, addBtn);
    });
  }

  /* =========================================================
     固定追従CTA
     ========================================================= */
  if (sticky) {
    var hero = root.querySelector('[data-lp-hero]');
    var ppAnchor = root.querySelector('[data-lp-pp]');
    var footer = document.querySelector('.site-footer, footer');

    function updateSticky() {
      var show = true;
      // heroを通過したら表示
      if (hero) {
        var hb = hero.getBoundingClientRect();
        if (hb.bottom > 60) show = false;
      }
      // 購入エリアが画面内なら隠す
      if (ppAnchor) {
        var pb = ppAnchor.getBoundingClientRect();
        if (pb.top < window.innerHeight && pb.bottom > 0) show = false;
      }
      // フッター表示時は隠す
      if (footer) {
        var fb = footer.getBoundingClientRect();
        if (fb.top < window.innerHeight) show = false;
      }
      sticky.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();

    var sBtn = sticky.querySelector('[data-lp-sticky-btn]');
    if (sBtn) sBtn.addEventListener('click', function (e) {
      track('lp_cta_click', { cta_text: (sBtn.textContent || '').trim(), cta_position: 'sticky' });
      // 単一variant確定 → 直接追加 / 未確定 → 購入エリアへ
      if (state.variant && state.variant.available && variants.length === 1) {
        e.preventDefault();
        addToCart(state.variant.id, sBtn);
      } else if (ppAnchor) {
        e.preventDefault();
        ppAnchor.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  /* =========================================================
     タブ切替 (packing_example / capacity)
     ========================================================= */
  root.querySelectorAll('[data-lp-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[data-lp-tab]');
    var panels = wrap.querySelectorAll('[data-lp-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-lp-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        panels.forEach(function (p) { p.setAttribute('data-active', p.getAttribute('data-lp-panel') === key ? 'true' : 'false'); });
        track('lp_tab_switch', { creative_name: (tab.textContent || '').trim() });
      });
    });
  });

  /* =========================================================
     pocket_map ホットスポット
     ========================================================= */
  root.querySelectorAll('[data-lp-pocketmap]').forEach(function (pm) {
    var pins = pm.querySelectorAll('[data-lp-pin]');
    var items = pm.querySelectorAll('[data-lp-pocket]');
    var stage = pm.querySelector('.lp-mugen5__pm-stage');
    var tip = null;
    if (stage) {
      tip = document.createElement('div');
      tip.className = 'lp-mugen5__pm-tip';
      tip.innerHTML = '<span class="lp-mugen5__pm-tip-name"></span><span class="lp-mugen5__pm-tip-desc"></span>';
      stage.appendChild(tip);
    }
    function showTip(pin) {
      if (!tip) return;
      tip.style.left = (pin.style.left || '50%');
      tip.style.top = (pin.style.top || '50%');
      tip.querySelector('.lp-mugen5__pm-tip-name').textContent = pin.getAttribute('data-name') || '';
      var desc = pin.getAttribute('data-desc') || '';
      tip.querySelector('.lp-mugen5__pm-tip-desc').textContent = desc;
      tip.classList.add('is-show');
    }
    function hideTip() { if (tip) tip.classList.remove('is-show'); }
    function activate(idx) {
      var activePin = null;
      pins.forEach(function (p) {
        var on = p.getAttribute('data-lp-pin') === String(idx);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) activePin = p;
      });
      items.forEach(function (li) { li.classList.toggle('is-active', li.getAttribute('data-lp-pocket') === String(idx)); });
      if (activePin) showTip(activePin); else hideTip();
    }
    pins.forEach(function (pin) {
      pin.addEventListener('click', function (e) { e.stopPropagation(); activate(pin.getAttribute('data-lp-pin')); });
    });
    items.forEach(function (li) {
      li.addEventListener('click', function () { activate(li.getAttribute('data-lp-pocket')); });
    });
    document.addEventListener('click', function (e) {
      if (stage && !stage.contains(e.target)) hideTip();
    });
  });
})();
